import { render, staticRenderFns } from "./Grid2x6.vue?vue&type=template&id=0a83bcfa"
import script from "./Grid2x6.vue?vue&type=script&lang=js"
export * from "./Grid2x6.vue?vue&type=script&lang=js"
import style0 from "./Grid2x6.vue?vue&type=style&index=0&id=0a83bcfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports